import { jsx } from "@builder.io/qwik/jsx-runtime";
import { component$, useContext, Slot } from "@builder.io/qwik";
import { HPopoverPanel } from "../popover/popover-panel.qwik.mjs";
import { TooltipContextId } from "./tooltip-context.qwik.mjs";
const HTooltipPanel = component$((props) => {
  const context = useContext(TooltipContextId);
  return /* @__PURE__ */ jsx(HPopoverPanel, {
    ...props,
    role: "tooltip",
    onToggle$: (e) => context.onOpenChange$(e.newState),
    id: context.localId,
    children: /* @__PURE__ */ jsx(Slot, {})
  });
});
export {
  HTooltipPanel
};
